// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function ChartLine(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "ChartLine" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M2 22V17.3531L5.15789 18.7674L10.8038 12.3311L14.488 16.4584L22 5V22H2Z", fill: "currentColor" }))));
});
//# sourceMappingURL=ChartLine.js.map